import React, { useState, useEffect } from 'react';
import { metrics, positions, applicants } from '../api';

function Dashboard() {
  const [stats, setStats] = useState({
    activePositions: 0,
    totalApplicants: 0,
    activeApplicants: 0,
    hiredCount: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const [positionsRes, applicantsRes, metricsRes] = await Promise.all([
        positions.getAll({ status: 'open' }),
        applicants.getAll({ status: 'active' }),
        metrics.getAll()
      ]);

      // Handle pagination format
      const activeCount = applicantsRes.data.pagination?.total ?? applicantsRes.data.data?.length ?? 0;

      setStats({
        activePositions: positionsRes.data.length,
        activeApplicants: activeCount,
        totalApplicants: metricsRes.data.applicants?.total || 0,
        hiredCount: metricsRes.data.applicants?.hired || 0
      });
    } catch (error) {
      console.error('Error loading dashboard:', error);
      alert('Error loading dashboard data. Please refresh the page.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="spinner"></div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Overview of recruitment activities</p>
      </div>

      <div className="grid grid-4">
        <div className="card">
          <h3 className="card-title">Active Positions</h3>
          <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--primary-color)' }}>
            {stats.activePositions}
          </div>
          <p className="text-secondary">Currently hiring</p>
        </div>

        <div className="card">
          <h3 className="card-title">Active Applicants</h3>
          <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--warning-color)' }}>
            {stats.activeApplicants}
          </div>
          <p className="text-secondary">Pending review</p>
        </div>

        <div className="card">
          <h3 className="card-title">Total Applicants</h3>
          <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--secondary-color)' }}>
            {stats.totalApplicants}
          </div>
          <p className="text-secondary">All time</p>
        </div>

        <div className="card">
          <h3 className="card-title">Hires</h3>
          <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--success-color)' }}>
            {stats.hiredCount}
          </div>
          <p className="text-secondary">Successfully hired</p>
        </div>
      </div>

      <div className="card mt-4">
        <h3 className="card-title">Quick Actions</h3>
        <div className="flex gap-2 mt-3">
          <button className="btn btn-primary" onClick={() => window.location.href = '/positions'}>
            Manage Positions
          </button>
          <button className="btn btn-secondary" onClick={() => window.location.href = '/active'}>
            View Active Applicants
          </button>
          <button className="btn btn-outline" onClick={() => window.location.href = '/metrics'}>
            View Metrics
          </button>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
